/* eslint-disable @typescript-eslint/ban-ts-comment, no-underscore-dangle */
// @ts-ignore
import _package from "../package.json";
export var collectPackageInfo = function collectPackageInfo(entityName) {
  if (typeof window === 'undefined') {
    return;
  }

  var name = _package.name,
      version = _package.version;

  if (!window.__PLASMA_INFO__) {
    window.__PLASMA_INFO__ = {};
  }

  if (!window.__PLASMA_INFO__[name]) {
    window.__PLASMA_INFO__[name] = {
      version: version,
      entities: [entityName]
    };
    return;
  }

  window.__PLASMA_INFO__[name].entities.push(entityName);
};